import { useParams, useRouteContext } from "@tanstack/react-router";
import {
  useGetCollectionSiteFromNamesQuery,
  useGetCollectionSiteQuery,
  useGetMeWithSitesQuery,
} from "generated/graphql";
import { useEffect } from "react";
import { useStickyState } from "src/utils/hooks/sticky-state";
import { useNavSiteStore } from "./nav-site-store";

export const useNavSites = () => {
  const { setNavSite, navSite } = useNavSiteStore();
  const { subdomain } = useRouteContext({ from: "__root__" });
  const [{ data, fetching: meFetching }] = useGetMeWithSitesQuery();
  const { siteSlug } = useParams({ strict: false });
  const [{ data: collectionSiteData, fetching: siteFetching }] =
    useGetCollectionSiteFromNamesQuery({
      variables: {
        organisationSubdomain: subdomain,
        collectionSiteSlug: siteSlug ?? "",
      },
      pause: siteSlug == null,
    });
  const [lastVisitedSiteId, _] = useStickyState("", "last-visited-siteId");
  const [{ data: recentlyVisitedCollectionSite, fetching: siteFetching2 }] =
    useGetCollectionSiteQuery({
      variables: { id: lastVisitedSiteId },
      pause: lastVisitedSiteId === "",
    });

  const sites = data?.me?.collectionSites;
  const firstSite = sites?.[0];
  const fetchedSite = collectionSiteData?.org?.site;

  useEffect(() => {
    setNavSite(
      fetchedSite ??
        recentlyVisitedCollectionSite?.collectionSite ??
        firstSite ??
        null,
    );
  }, [
    fetchedSite,
    navSite,
    setNavSite,
    firstSite,
    recentlyVisitedCollectionSite,
  ]);

  return {
    activeSite:
      fetchedSite ?? recentlyVisitedCollectionSite?.collectionSite ?? firstSite,
    sites,
    fetching: meFetching || siteFetching || siteFetching2,
  };
};
